import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {IncidentsFilters} from "@/pages/incidents/IncidentsFilters.tsx";

interface IncidentsControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const IncidentsControlBar = ({search, setSearch, filterSets, onFilterSetChange}: IncidentsControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <IncidentsFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
    />
  );
};
